// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import 'babel-polyfill'

Vue.config.productionTip = false
//axios http
import axios from 'axios'
import {post,fetch,patch,put} from './components/service/http-service.js'
//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
//language
import i18n from './i18n'

//bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

//select
import 'vue-bootstrap-selectpicker/dist/css/vue-bootstrap-selectpicker.min.css'
import SelectPicker from 'vue-bootstrap-selectpicker'
Vue.use(SelectPicker)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
//import 'swiper/dist/css/swiper.css'

// 引入vuex-store
import store from './vuex/store';

//表单验证
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

//手動觸發Google Analytics
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'G-PTMJKKSEBM', // 从配置中读取
  disableScriptLoader: true, // 必须在html中完成初始化，这里显式禁止去下载ga脚本
  router, // 确保路由切换时可以自动统计
  autoTracking: {
    pageviewOnLoad: false // 当通过网址进来时已经GA在初始化时就发起一次pageview的统计，这里不要重复统计
  }
})

import './assets/css/common.scss'
import './assets/js/common.js'



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n: i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js